<template>
   <div :class="col">
      <div class="mb-0 position-relative sa-field">
         <!-- Label above the box (main.js formStyle 'icons' and 'plain') -->
         <label v-if="label && !floating" :for="inputId" class="form-label">{{ label }}</label>

         <div :class="wrapClass" @focusin="focused = true" @focusout="focused = false">
            <!-- Icon in front (formStyle 'icons' only) -->
            <span v-if="showIcon" class="input-group-text"><i :class="icon"></i></span>

            <input
               v-bind="$attrs"
               :id="inputId"
               :type="visible ? 'text' : 'password'"
               :value="modelValue"
               :placeholder="floating ? ' ' : placeholder"
               :autocomplete="autocomplete"
               @input="$emit('update:modelValue', $event.target.value)"
               class="form-control custom-tooltip-input"
            />

            <!-- Floating label (formStyle 'floating') -->
            <label v-if="floating" :for="inputId" class="sa-float-label">{{ label }}</label>

            <!-- Show / hide the password -->
            <button
               type="button"
               class="sa-password-eye"
               :title="visible ? 'Hide password' : 'Show password'"
               :aria-label="visible ? 'Hide password' : 'Show password'"
               tabindex="-1"
               @mousedown.prevent
               @click="visible = !visible"
            >
               <i class="fa" :class="visible ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
         </div>

         <small v-if="hint" class="text-muted d-block">{{ hint }}</small>

         <!-- Above the box: on focus, and in red while the field is invalid -->
         <div v-if="tooltip" class="custom-tooltip">{{ tooltip }}<span class="tooltip-arrow"></span></div>
      </div>
   </div>
</template>

<script>
// A password box with an eye to show / hide what was typed.
//   <PasswordField v-model="formInputs.password" name="password" label="Password" icon="fa fa-lock"
//                  minlength="8" tooltip="At least 8 characters" required col="col-md-6" />
//   <PasswordField v-model="formInputs.confirm" label="Confirm password" icon="fa fa-lock"
//                  data-match="password" tooltip="Must be the same as the password" required col="col-md-6" />
// Looks follow main.js formStyle. name, required, minlength, pattern, data-match ... go to the <input>.
// autocomplete: "new-password" (default, for new / changed passwords) or "current-password" (login).
let nextId = 0;

export default {
   name: "PasswordField",
   inheritAttrs: false,
   props: {
      modelValue: { default: "" },
      label: { type: String, default: "" },
      icon: { type: String, default: "" },
      placeholder: { type: String, default: "" },
      tooltip: { type: String, default: "" },
      hint: { type: String, default: "" },
      col: { type: String, default: "col-md-6" },
      autocomplete: { type: String, default: "new-password" },
      id: { type: String, default: "" },
   },
   emits: ["update:modelValue"],
   data() {
      return { autoId: "password-field-" + ++nextId, focused: false, visible: false };
   },
   computed: {
      inputId() {
         return this.id || this.autoId;
      },
      formStyle() {
         return this.$formStyle || "icons";
      },
      floating() {
         return this.formStyle === "floating" && !!this.label;
      },
      showIcon() {
         return this.formStyle === "icons" && !!this.icon;
      },
      wrapClass() {
         const base = { "sa-password": true, "position-relative": true };
         if (this.showIcon) return { ...base, "input-group": true };
         if (this.floating) {
            return {
               ...base,
               "sa-float": true,
               "is-up": this.focused || String(this.modelValue ?? "") !== "",
               "is-focused": this.focused,
            };
         }
         return base;
      },
   },
};
</script>